import React, { useState, useRef, useEffect } from "react";
import { Button, ConfigProvider, Divider, Select } from "antd";
import styles from "./AntMultiSelectDropdown.module.css";
import "./AntMultiSelectDropdown.css";

const AntMultiSelectDropdown = ({
  value,
  options,
  fieldNames,
  onChanged,
  selectLabelHeading,
  selectLabelStatus,
  selectAllLabel,
  unselectAllLabel,
  noContentLabel,
}) => {
  /*
    value:        array of selected options values
    options:      array of objects
    filedNames:   { value: <key>, label: <key> }
    onChanged:    value array setter
    asFunnelIcon: replace input with funnel icon    
  */

  const containerRef = useRef(null);
  const [all, setAll] = useState(true);
  const [open, setOpen] = useState(false);
  const [timerActive, setTimerActive] = useState(false);

  const handleChange = (args) => {
    onChanged(args);
  };

  const handleSelectAllClick = () => {
    if (all) {
      onChanged([]);
    } else {
      onChanged(options.map((option) => option[fieldNames.value]));
    }
  };

  useEffect(() => {
    setAll(value?.length === options?.length);
  }, [value, options]);

  useEffect(() => {
    // A time delay is needed to delay effective execution
    //  of the Select onDropdownVisibleChange method.
    //  Otherwise it may trigger before the 'open' state
    //  is updated.
    const timeoutId = setTimeout(() => {
      if (timerActive) {
        setOpen(false);
      }
      setTimerActive(false);
    }, 400);

    return () => {
      clearTimeout(timeoutId); // Remove timer on unmount
    };
  }, [open, timerActive]);

  return (
    <div ref={containerRef} className="ant-multiSelectDropdown-000">
      <div
        className={styles.AntMultiSelectDropdown__select}
        onClick={() => {
          setOpen((prevState) => !prevState);
        }}
        style={{ cursor: "pointer" }}
      >
        <p className={styles.AntMultiSelectDropdown__selectLabelHeading}>
          {selectLabelHeading}
        </p>
        <p className={styles.AntMultiSelectDropdown__selectLabelStatus}>
          {selectLabelStatus}
        </p>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionSelectedBg: "var(--green)", // Selected background
              optionSelectedColor: "white", // Selected text
              colorPrimary: "white", // Selected checkmark
              optionActiveBg: "white", // Last clicked background
              colorTextDisabled: "black", // noContentLabel text
            },
          },
        }}
      >
        <Select
          style={
            open
              ? {
                  border: "none",
                  outline: "none",
                }
              : { width: 0, height: 0, opacity: 0 }
          }
          mode="multiple"
          value={value}
          options={options}
          fieldNames={fieldNames}
          allowClear={true}
          open={open}
          onDropdownVisibleChange={() => {
            setTimerActive(true);
          }}
          getPopupContainer={() => containerRef.current}
          popupMatchSelectWidth={false}
          placeholder=""
          notFoundContent={noContentLabel}
          onChange={handleChange}
          dropdownStyle={{ minWidth: 240 }}
          dropdownRender={
            options.length > 0 && selectAllLabel && unselectAllLabel
              ? (menu) => (
                  <>
                    <div>
                      <Button type="text" onClick={handleSelectAllClick}>
                        {all ? unselectAllLabel : selectAllLabel}
                      </Button>
                    </div>
                    <Divider style={{ margin: "4px 0" }} />
                    {menu}
                  </>
                )
              : undefined
          }
        />
      </ConfigProvider>
    </div>
  );
};

export default AntMultiSelectDropdown;
